export default "__VITE_ASSET__OwzNlDXN__"